import React, { useState, useContext, useEffect } from "react"
import "./login.css"
import LoginForm from "./LoginForm"
import SignupForm from "./signupForm"
import { motion } from "framer-motion"
import { serverAPI } from "../../services/api/apiParams"
import { Redirect } from "react-router-dom"
import { userContext } from "../../App"
import Alert from "react-bootstrap/Alert"
import Cookies from "universal-cookie"

//framer animation
const backdropVariants = {
  expanded: {
    width: "233%",
    height: "1300px",
    bordRadius: "20%",
    transform: "rotate(0deg)",
  },
  collapsed: {
    width: "160%",
    height: "550px",
    bordRadius: "50%",
    transform: "rotate(60deg)",
  },
}
function Login() {
  const { user, setUser } = useContext(userContext)

  const [loginInfo, setLoginInfo] = useState({ email: "", password: "" })
  const [registerInfo, setRegisterInfo] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    password_confirm: "",
  })
  const [redirectToHome, setRedirectToHome] = useState(false)
  const [registerSuccess, setRegisterSuccess] = useState(false)
  const [loginErrorMsg, setLoginErrorMsg] = useState()
  const [registerErrorMsg, setRegisterErrorMsg] = useState()

  const ChangeHandlerLogin = (e) => {
    setLoginInfo({ ...loginInfo, [e.target.name]: e.target.value })
  }
  const ChangeHandlerRegister = (e) => {
    setRegisterInfo({ ...registerInfo, [e.target.name]: e.target.value })
  }
  const login = async () => {
    try {
      const result = await serverAPI.post("api/login", loginInfo, {
        headers: {
          Accept: "application/json",
        },
      })
      const signedUser = result.data.user
      setUser(signedUser)
      setLoginInfo({ email: "", password: "" })
      setRedirectToHome(true)
      const cookies = new Cookies()
      cookies.set("auth_token", result.data.jwt)
    } catch (e) {
      setLoginErrorMsg(e.response.data.error)
    }
  }
  const register = async () => {
    try {
      await serverAPI.post("api/register", registerInfo, {
        headers: {
          Accept: "application/json",
        },
      })
      setRegisterInfo({
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password_confirm: "",
      })
      setlogin(true)
      setRegisterSuccess(true)
    } catch (e) {
      setRegisterErrorMsg(e.response.data.errors)
    }
  }

  //framer animation start
  const [isExpanded, setExpanded] = useState(false)
  const [loginForm, setlogin] = useState(true)

  const loginToSignup = () => {
    playExpandingAnimation()
    setlogin((prev) => !prev)
    setRegisterSuccess(false)
  }
  const playExpandingAnimation = () => {
    setExpanded(true)
    setTimeout(() => {
      setExpanded(false)
    }, expandingTransition.duration * 1000 - 1500)
  }
  const expandingTransition = {
    type: "spring",
    duration: 2,
    stiffness: 30,
  }
  //framer animation end

  if (redirectToHome) {
    return <Redirect to='/' />
  }

  return (
    <div className='Page'>
      {registerSuccess && (
        <Alert className='mt-5 alert'>Account Created! please log in</Alert>
      )}

      <div className='loginContainer'>
        <div className='topContainer'>
          <motion.div
            initial={false}
            className='backDrop'
            variants={backdropVariants}
            animate={isExpanded ? "expanded" : "collapsed"}
            transition={expandingTransition}></motion.div>
          <div className='headerContainer'>
            <h2 className='headerText'>{loginForm ? "Login" : "Sign UP"}</h2>
            <h5 className='smallText'>Welcome {loginForm ? "Back" : ""}!</h5>
          </div>
        </div>
        {loginForm ? (
          <LoginForm
            loginToSignup={loginToSignup}
            ChangeHandlerLogin={ChangeHandlerLogin}
            Login={login}
            loginInfo={loginInfo}
            loginErrorMsg={loginErrorMsg}></LoginForm>
        ) : (
          <SignupForm
            loginToSignup={loginToSignup}
            ChangeHandlerRegister={ChangeHandlerRegister}
            register={register}
            registerInfo={registerInfo}
            registerErrorMsg={registerErrorMsg}></SignupForm>
        )}
      </div>
    </div>
  )
}

export default Login
